import React from 'react';
import styled from '@emotion/styled';
import { useMegaMenu } from './MegaMenuContext';
import { cwRTLTranslate, flyoutPanelTransition, MegaMenuCSSCustomProperties, megaMenuZIndexes, } from './MegaMenu.config';
import * as Icons from '@polestar/component-warehouse-react/tokens/icons/Icons';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import IconButton from '@polestar/component-warehouse-react/components/icon-button/IconButton';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import MediaQueries from '@polestar/component-warehouse-react/tokens/media-queries/MediaQueries';
import Grids from '@polestar/component-warehouse-react/tokens/grids/Grids';
import { keyboardOnlyStyle, pointerOnlyStyle, } from '@polestar/component-warehouse-react/helpers/accessibility';
import { css } from '@emotion/react';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import useTrackingData from '@polestar/component-warehouse-react/hooks/useTrackingData';
import { DataLayerAction, DataLayerCategory, DataLayerEvent, DataLayerLabel, } from '@polestar/component-warehouse-react/tokens/analytics/Analytics';
var SharedCloseButtonCustomProperty;
(function (SharedCloseButtonCustomProperty) {
    SharedCloseButtonCustomProperty["translate"] = "--cw-mega-shared-close-button-translate";
})(SharedCloseButtonCustomProperty || (SharedCloseButtonCustomProperty = {}));
// TODO: need to pushed into PrimaryNavigation & SecondaryNavigation but animation needs to different so the tab focus works as expected
export const MegaMenuSharedCloseButton = ({ closeButtonLabel }) => {
    const { menuActive, flyoutActive } = useMegaMenu();
    return (React.createElement(Wrapper, { style: {
            [SharedCloseButtonCustomProperty.translate]: menuActive || flyoutActive ? '0' : '100%',
        } },
        React.createElement(StaticCloseButton, { "aria-label": closeButtonLabel })));
};
const Wrapper = styled.div `
  ${SharedCloseButtonCustomProperty.translate}: 0;
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: ${megaMenuZIndexes.sharedCloseButton};
  translate: calc(var(${SharedCloseButtonCustomProperty.translate}) * var(${cwRTLTranslate}, 1)) 0;
  transition: ${flyoutPanelTransition};
  transition-duration: var(${MegaMenuCSSCustomProperties.flyoutTransitionDuration});

  ${MediaQueries.tablet} {
    inset-inline: auto 0;
    inline-size: min(100%, var(${MegaMenuCSSCustomProperties.tabletMaxInlineSize}));
  }

  ${MediaQueries.desktop} {
    display: none;
  }

  ${keyboardOnlyStyle} {
    /* only show when pointer is enabled to be able to show the animation */
    display: none;
  }
`;
export const StaticCloseButton = (props) => {
    const { setMenuActive, setActiveFlyoutIndex, setFlyoutActive } = useMegaMenu();
    const { pushDataLayer } = useTrackingData();
    const closeMenu = () => {
        setMenuActive(false);
        setFlyoutActive(false);
        setActiveFlyoutIndex(null);
        pushDataLayer({
            event: DataLayerEvent.LINK_CLICK,
            category: DataLayerCategory.MENU,
            action: DataLayerAction.MENU_CLICK,
            label: DataLayerLabel.MENU_CLOSED,
        });
    };
    return (React.createElement(StyledCloseButton, { icon: Icons.close, size: Sizes.large, onMouseDown: closeMenu, onClick: closeMenu, hideOnPointer: (props === null || props === void 0 ? void 0 : props.hideOnPointer) || false, ...props }));
};
const CloseButton = styled(IconButton, shouldNotForwardProps(false, 'hideOnPointer'))(({ hideOnPointer }) => css(css `
      position: absolute;
      /* todo: should align with the menu button, which it does now, but the solution for these icon alignments is a bit icky */
      inset-block: ${Spacings.xxSmall} auto;
      inset-inline: auto calc(2 * ${Grids.mobile.gutter} - ${createCustomSpacing(12 / 16)});

      ${MediaQueries.tablet} {
        inset-block-start: ${Spacings.xSmall};
        inset-inline: auto
          calc(${Spacings.large} + ${Grids.tablet.gutter} - ${createCustomSpacing(12 / 16)});
      }
    `, hideOnPointer &&
    css `
        ${pointerOnlyStyle} {
          /* hide when pointer is enabled to be able to show the animated close button */
          display: none;
        }
      `));
const StyledCloseButton = styled(CloseButton) `
  pointer-events: auto;

  /* The close button has no place on desktop and can be hidden because of that */
  ${MediaQueries.desktop} {
    display: none;
  }
`;
